import {AbstractControl} from '@angular/forms';

export function emailFormatValidator(control: AbstractControl) {
  let valid = false;
  let isSpace= false;
  if(control.value){
    Object.values(control.value).forEach(l => {
      if(l === ' '){
        isSpace= true;
        valid = false;
      }
    });
  }
  let emailValid = control.value ? control.value.split('@') : null;
  if(emailValid){
    if (
      emailValid.length === 2 &&
      emailValid[0] !== '' &&
      emailValid[1] !== '' &&
      emailValid[1] &&
      emailValid[1].includes('.') >= 0 &&
      emailValid[1].split('.').length >= 2 &&
      emailValid[1].split('.')[1] !== '' &&
      emailValid[1].substr(-1) !== '.' && !isSpace
      ) {
        valid = true
      }
  }
  return valid ? null : {invalidFormat: !valid};
}
